export default __webpack_public_path__ + "static/service-dedicated-845d4a3e6d27cefcdda0489e0356f0cd.jpg";